import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'secondary' | 'ghost' | 'onDark' | 'danger';
type Size = 'sm' | 'md' | 'lg';
const base = 'inline-flex items-center justify-center gap-2 font-sans font-medium tracking-tight whitespace-nowrap rounded-sm transition-[background-color,border-color,color,transform] duration-120 ease-institutional active:translate-y-px disabled:opacity-45 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  primary: 'bg-gold text-ink hover:bg-gold-400 border border-gold',
  secondary: 'bg-white text-ink border border-navy-100 hover:border-navy-400 hover:bg-parchment',
  ghost: 'bg-transparent text-navy-700 border border-transparent hover:bg-parchment-200',
  onDark: 'bg-transparent text-parchment border border-navy-300 hover:border-gold hover:text-gold-200',
  danger: 'bg-white text-state-negative border border-state-negative/40 hover:bg-state-negative/5'
};
const sizes: Record<Size, string> = {
  sm: 'text-[0.8125rem] px-3 py-1.5',
  md: 'text-sm px-5 py-2.5',
  lg: 'text-[0.9375rem] px-7 py-3.5'
};
interface CommonProps {
  variant?: Variant;
  size?: Size;
  full?: boolean;
  className?: string;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  full,
  className = '',
  children,
  ...rest
}: CommonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type={rest.type ?? 'button'} className={`${base} ${variants[variant]} ${sizes[size]} ${full ? 'w-full' : ''} ${className}`} {...rest} data-id="element-532" data-mp="12mjxxt4n6r11">
      {children}
    </button>;
}
export function ButtonLink({
  to,
  variant = 'primary',
  size = 'md',
  full,
  className = '',
  children,
  ...rest
}: CommonProps & {
  to: string;
} & Omit<React.ComponentProps<typeof Link>, 'to' | 'className' | 'children'>) {
  return <Link to={to} className={`${base} ${variants[variant]} ${sizes[size]} ${full ? 'w-full' : ''} ${className}`} {...rest} data-id="element-533" data-mp="1lbqg9f1ixgmb">
      {children}
    </Link>;
}